import categories from '../categories.json';
import { PostEntity } from '../types';

export const getAllPostsFromCategory = (posts: PostEntity[], category: string): PostEntity[] =>
    posts.filter((post) => post.categories.includes(category));

export const getAllCategories = (): { params: { id: string } }[] =>
    Object.values(categories).map(({ slug }) => ({
        params: {
            id: slug
        }
    }));
